import React, { useState } from 'react';
import { toast } from 'react-toastify';

import '../../css/modal.css';
import { createCustomer } from '../../api/Customer';
import { Customer } from '../../types/Customer';

interface CustomerCreateModalProps {
  onClose: () => void;
  onCustomerCreated: (id: number) => void;
}

const CustomerCreateModal: React.FC<CustomerCreateModalProps> = ({ onClose, onCustomerCreated }) => {
  const [formData, setFormData] = useState<Customer>({
    name: '',
    email: '',
    phoneNumber: '',
    city: '',
    address: '',
    profession: '',
    latitude: '',
    longitude: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const { name, email, phoneNumber } = formData;

    if (!name || !email || !phoneNumber) {
      toast.error('Name, Email, and Phone are required.');
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.warning('Enter a valid email address.');
      return false;
    }

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(formData.phoneNumber)) {
      toast.warning("Enter a valid 10-digit phone number.");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const updatedFormData = {
            ...formData,
            latitude: latitude.toString(),
            longitude: longitude.toString(),
            phoneNumber: `+91${formData.phoneNumber}`
          };

          try {
            const newCustomer = await createCustomer(updatedFormData);
            toast.success('Customer created successfully!');
            onCustomerCreated(newCustomer.id);
          } catch (error) {
            toast.error('Failed to create customer.');
          }
        },
        () => {
          toast.error('Please allow location access to continue.');
        }
      );
    } else {
      toast.error('Geolocation not supported by this browser.');
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>Add Customer</h2>
        <input name="name" placeholder="Customer Name *" onChange={handleChange} />
        <input name="email" placeholder="Email ID *" onChange={handleChange} />
        <div className="phone-input-wrapper">
          <span className="country-code">+91</span>
          <input name="phoneNumber" placeholder="Phone Number *" onChange={handleChange} />
        </div>
        <input name="address" placeholder="Address" onChange={handleChange} />
        <input name="city" placeholder="City" onChange={handleChange} />
        <input name="profession" placeholder="Profession" onChange={handleChange} />
        <div className="modal-actions">
          <button onClick={handleSubmit}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default CustomerCreateModal;
